import { globalStores } from 'stores/global';

export const womBaseURL = () => globalStores.womBaseURL.getState();
